import { Controller } from '@hotwired/stimulus';

const MONTHS = {
  jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6,
  jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12,
};

export default class extends Controller {
  static targets = ['dateInput'];

  connect() {
    this.boundBlockAutoSubmit = this.blockAutoSubmit.bind(this);
    this.boundConvertFormData = this.convertFormData.bind(this);

    this.element.addEventListener('submit', this.boundBlockAutoSubmit, true);
    this.element.addEventListener('formdata', this.boundConvertFormData);
  }

  disconnect() {
    this.element.removeEventListener('submit', this.boundBlockAutoSubmit, true);
    this.element.removeEventListener('formdata', this.boundConvertFormData);
  }

  blockAutoSubmit(event) {
    if (!event.submitter) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  submitOnEnter(event) {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    const submitButton = this.element.querySelector('button[type="submit"]');
    this.element.requestSubmit(submitButton);
  }

  // Rewrite date entries to ISO on the FormData (not the visible input) so the
  // user-facing value stays in DD/MM/YYYY or ordinal format — no flicker on submit.
  convertFormData(event) {
    this.dateInputTargets.forEach((input) => {
      const name = input.name;
      if (!name) return;
      const original = event.formData.get(name);
      if (original === null) return;
      const iso = this.toIso(String(original));
      if (iso === null || iso === '') {
        event.formData.delete(name);
      } else {
        event.formData.set(name, iso);
      }
    });
  }

  toIso(value) {
    if (!value) return '';
    const trimmed = value.trim();
    if (!trimmed) return '';

    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;

    const slashMatch = trimmed.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
    if (slashMatch) {
      const [, d, m, y] = slashMatch;
      return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
    }

    const ordinalMatch = trimmed.match(/^(\d{1,2})(?:st|nd|rd|th)?\s+([a-zA-Z]{3})\s+(\d{4})$/);
    if (ordinalMatch) {
      const [, d, monthAbbr, y] = ordinalMatch;
      const m = MONTHS[monthAbbr.toLowerCase()];
      if (m) {
        return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
      }
    }

    return null;
  }
}
